import { removeLeadingPlus } from 'utils/utils'
import agent from './agent'

export function globalSearch(type: string, query: string) {
  return agent.get('/global-search', { params: {
    type,
    query: removeLeadingPlus(query)
  } })
}
